exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container,body,html{margin:0;padding:0;font-family:Roboto,sans-serif}#root,body,html{height:100%}body{background-color:#000;color:#fff;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}body:-webkit-full-screen{width:100%;overflow-y:auto;position:relative;-webkit-overflow-scrolling:touch}h1,h2,h3,h4,h5,h6{margin:0;font-family:Stanley,serif;font-weight:400}h1{font-size:40px}a{text-decoration:none}a.active{border-bottom:1px solid #00ff40;padding-bottom:5px}p{margin:0;letter-spacing:.5px;line-height:24px;font-size:16px}.App{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/components/App.scss
// module id = 281
// module chunks = 0